import HtmlIcon from "../assets/icons/html5-original.svg";
import CssIcon from "../assets/icons/css3-original.svg";
import JsIcon from "../assets/icons/javascript-original.svg";
import ReactIcon from "../assets/icons/react-original.svg";
import NodeIcon from "../assets/icons/nodejs-original.svg";
import GitIcon from "../assets/icons/git-original.svg";
import PythonIcon from "../assets/icons/python-orginal.svg"

export const devSkills = {
    htmlSkill: {
        id: 0,
        name: "HTML",
        icon: HtmlIcon,
        color: "error",
    },
    cssSkill: {
        id: 1,
        name: "CSS",
        icon: CssIcon,
        color: "info",
    },
    jsSkill: {
        id: 2,
        name: "JavaScript",
        icon: JsIcon,
        color: "warning",
    },
    reactSkill: {
        id: 3,
        name: "React",
        icon: ReactIcon,
        color: "info",
    },
    nodeSkill: {
        id: 4,
        name: "NodeJS",
        icon: NodeIcon,
        color: "success",
    },
    gitSkill: {
        id: 5,
        name: "Git",
        icon: GitIcon,
        color: "secondary",
    },
    pythonSkill: {
        id: 6,
        name: "Python",
        icon: PythonIcon,
        color: "warning",
    },
};
